import { createFileRoute } from '@tanstack/react-router'

import { BulkPaymentHistoryPage } from '@/components/pages/Admin/Outstanding/BulkSettle/BulkPaymentHistoryPage'

export const Route = createFileRoute('/(dashboard)/admin/outstanding/history')({
  component: BulkPaymentHistoryRoute,
})

function BulkPaymentHistoryRoute() {
  return <BulkPaymentHistoryPage />
}
